export const taxForms = {
  individual: [
    {
      id: "1040",
      number: "Form 1040",
      name: "U.S. Individual Income Tax Return",
      description: "Standard form for filing individual federal income tax returns",
      popular: true,
      pdfUrl: "https://www.irs.gov/pub/irs-pdf/f1040.pdf",
      guideUrl: "https://www.irs.gov/forms-pubs/about-form-1040"
    },
    {
      id: "1040-sr",
      number: "Form 1040-SR",
      name: "U.S. Tax Return for Seniors",
      description: "Simplified tax return for taxpayers age 65 and older",
      pdfUrl: "https://www.irs.gov/pub/irs-pdf/f1040s.pdf",
      guideUrl: "https://www.irs.gov/forms-pubs/about-form-1040-sr"
    },
    {
      id: "schedule-a",
      number: "Schedule A",
      name: "Itemized Deductions",
      description: "Report itemized deductions including medical, taxes, interest, and charitable contributions",
      pdfUrl: "https://www.irs.gov/pub/irs-pdf/f1040sa.pdf",
      guideUrl: "https://www.irs.gov/forms-pubs/about-schedule-a-form-1040"
    },
    {
      id: "schedule-c",
      number: "Schedule C",
      name: "Profit or Loss From Business",
      description: "Report income or loss from a business you operated or profession you practiced",
      pdfUrl: "https://www.irs.gov/pub/irs-pdf/f1040sc.pdf",
      guideUrl: "https://www.irs.gov/forms-pubs/about-schedule-c-form-1040"
    },
    {
      id: "schedule-d",
      number: "Schedule D",
      name: "Capital Gains and Losses",
      description: "Report sales and exchanges of capital assets including stocks and bonds",
      pdfUrl: "https://www.irs.gov/pub/irs-pdf/f1040sd.pdf",
      guideUrl: "https://www.irs.gov/forms-pubs/about-schedule-d-form-1040"
    },
    {
      id: "schedule-e",
      number: "Schedule E",
      name: "Supplemental Income and Loss",
      description: "Report rental real estate, royalties, partnerships, S corporations, estates, trusts",
      pdfUrl: "https://www.irs.gov/pub/irs-pdf/f1040se.pdf",
      guideUrl: "https://www.irs.gov/forms-pubs/about-schedule-e-form-1040"
    },
    {
      id: "1040-x",
      number: "Form 1040-X",
      name: "Amended U.S. Individual Income Tax Return",
      description: "Correct errors or make changes to a previously filed tax return",
      pdfUrl: "https://www.irs.gov/pub/irs-pdf/f1040x.pdf",
      guideUrl: "https://www.irs.gov/forms-pubs/about-form-1040-x"
    },
    {
      id: "w-2",
      number: "Form W-2",
      name: "Wage and Tax Statement",
      description: "Reports wages paid and taxes withheld by employers",
      pdfUrl: "https://www.irs.gov/pub/irs-pdf/fw2.pdf",
      guideUrl: "https://www.irs.gov/forms-pubs/about-form-w-2"
    }
  ],
  business: [
    {
      id: "1099-nec",
      number: "Form 1099-NEC",
      name: "Nonemployee Compensation",
      description: "Report payments to independent contractors and freelancers",
      pdfUrl: "https://www.irs.gov/pub/irs-pdf/f1099nec.pdf",
      guideUrl: "https://www.irs.gov/forms-pubs/about-form-1099-nec"
    },
    {
      id: "1099-misc",
      number: "Form 1099-MISC",
      name: "Miscellaneous Information",
      description: "Report various types of miscellaneous income",
      pdfUrl: "https://www.irs.gov/pub/irs-pdf/f1099msc.pdf",
      guideUrl: "https://www.irs.gov/forms-pubs/about-form-1099-misc"
    },
    {
      id: "1065",
      number: "Form 1065",
      name: "U.S. Return of Partnership Income",
      description: "Information return filed by partnerships to report income, deductions, and credits",
      pdfUrl: "https://www.irs.gov/pub/irs-pdf/f1065.pdf",
      guideUrl: "https://www.irs.gov/forms-pubs/about-form-1065"
    },
    {
      id: "schedule-k1",
      number: "Schedule K-1",
      name: "Partner's Share of Income",
      description: "Reports each partner's share of partnership income, deductions, and credits",
      pdfUrl: "https://www.irs.gov/pub/irs-pdf/f1065sk1.pdf",
      guideUrl: "https://www.irs.gov/forms-pubs/about-schedule-k-1-form-1065"
    },
    {
      id: "1120",
      number: "Form 1120",
      name: "U.S. Corporation Income Tax Return",
      description: "Income tax return filed by C corporations",
      pdfUrl: "https://www.irs.gov/pub/irs-pdf/f1120.pdf",
      guideUrl: "https://www.irs.gov/forms-pubs/about-form-1120"
    },
    {
      id: "1120-s",
      number: "Form 1120-S",
      name: "U.S. Income Tax Return for S Corporation",
      description: "Income tax return filed by S corporations",
      pdfUrl: "https://www.irs.gov/pub/irs-pdf/f1120s.pdf",
      guideUrl: "https://www.irs.gov/forms-pubs/about-form-1120-s"
    }
  ],
  specialized: [
    {
      id: "5500",
      number: "Form 5500",
      name: "Annual Return/Report of Employee Benefit Plan",
      description: "Required annual report for employee benefit plans",
      pdfUrl: "https://www.dol.gov/sites/dolgov/files/ebsa/employers-and-advisers/plan-administration-and-compliance/reporting-and-filing/form-5500/2023-form-5500.pdf",
      guideUrl: "https://www.dol.gov/agencies/ebsa/employers-and-advisers/plan-administration-and-compliance/reporting-and-filing/form-5500"
    },
    {
      id: "1098",
      number: "Form 1098",
      name: "Mortgage Interest Statement",
      description: "Reports mortgage interest of $600 or more paid during the year",
      pdfUrl: "https://www.irs.gov/pub/irs-pdf/f1098.pdf",
      guideUrl: "https://www.irs.gov/forms-pubs/about-form-1098"
    }
  ]
};

export const stateFormsData = [
  {
    state: "Alabama",
    agency: "Alabama Department of Revenue",
    agencyUrl: "https://revenue.alabama.gov/",
    forms: [
      { name: "Form 40", description: "Individual Income Tax Return", pdfUrl: "https://revenue.alabama.gov/individual-corporate/individual-income-tax-forms/" }
    ]
  },
  {
    state: "Alaska",
    agency: "Alaska Department of Revenue",
    agencyUrl: "https://tax.alaska.gov/",
    forms: [
      { name: "No State Income Tax", description: "Alaska does not have a state income tax", pdfUrl: "" }
    ]
  },
  {
    state: "Arizona",
    agency: "Arizona Department of Revenue",
    agencyUrl: "https://azdor.gov/",
    forms: [
      { name: "Form 140", description: "Resident Personal Income Tax Return", pdfUrl: "https://azdor.gov/forms/individual" }
    ]
  },
  {
    state: "Arkansas",
    agency: "Arkansas Department of Finance and Administration",
    agencyUrl: "https://www.dfa.arkansas.gov/",
    forms: [
      { name: "Form AR1000", description: "Individual Income Tax Return", pdfUrl: "https://www.dfa.arkansas.gov/income-tax/individual-income-tax-forms" }
    ]
  },
  {
    state: "California",
    agency: "California Franchise Tax Board",
    agencyUrl: "https://www.ftb.ca.gov/",
    forms: [
      { name: "Form 540", description: "California Resident Income Tax Return", pdfUrl: "https://www.ftb.ca.gov/forms/2023/2023-540.pdf" },
      { name: "Form 540NR", description: "Nonresident or Part-Year Resident Income Tax Return", pdfUrl: "https://www.ftb.ca.gov/forms/2023/2023-540nr.pdf" }
    ]
  },
  {
    state: "Colorado",
    agency: "Colorado Department of Revenue",
    agencyUrl: "https://tax.colorado.gov/",
    forms: [
      { name: "Form 104", description: "Individual Income Tax Return", pdfUrl: "https://tax.colorado.gov/individual-income-tax-forms" }
    ]
  },
  {
    state: "Connecticut",
    agency: "Connecticut Department of Revenue Services",
    agencyUrl: "https://portal.ct.gov/DRS",
    forms: [
      { name: "Form CT-1040", description: "Resident Income Tax Return", pdfUrl: "https://portal.ct.gov/DRS/DRS-Forms/Current-Year-Forms/Income-Tax-Forms" }
    ]
  },
  {
    state: "Delaware",
    agency: "Delaware Division of Revenue",
    agencyUrl: "https://revenue.delaware.gov/",
    forms: [
      { name: "Form 200-01", description: "Resident Individual Income Tax Return", pdfUrl: "https://revenue.delaware.gov/individual-taxes/" }
    ]
  },
  {
    state: "Florida",
    agency: "Florida Department of Revenue",
    agencyUrl: "https://floridarevenue.com/",
    forms: [
      { name: "No State Income Tax", description: "Florida does not have a state income tax", pdfUrl: "" }
    ]
  },
  {
    state: "Georgia",
    agency: "Georgia Department of Revenue",
    agencyUrl: "https://dor.georgia.gov/",
    forms: [
      { name: "Form 500", description: "Individual Income Tax Return", pdfUrl: "https://dor.georgia.gov/individual-income-taxes" }
    ]
  },
  {
    state: "Hawaii",
    agency: "Hawaii Department of Taxation",
    agencyUrl: "https://tax.hawaii.gov/",
    forms: [
      { name: "Form N-11", description: "Individual Income Tax Return", pdfUrl: "https://tax.hawaii.gov/forms/" }
    ]
  },
  {
    state: "Idaho",
    agency: "Idaho State Tax Commission",
    agencyUrl: "https://tax.idaho.gov/",
    forms: [
      { name: "Form 40", description: "Individual Income Tax Return", pdfUrl: "https://tax.idaho.gov/forms.cfm" }
    ]
  },
  {
    state: "Illinois",
    agency: "Illinois Department of Revenue",
    agencyUrl: "https://www2.illinois.gov/rev/",
    forms: [
      { name: "Form IL-1040", description: "Individual Income Tax Return", pdfUrl: "https://www2.illinois.gov/rev/forms/incometax/Pages/default.aspx" }
    ]
  },
  {
    state: "Indiana",
    agency: "Indiana Department of Revenue",
    agencyUrl: "https://www.in.gov/dor/",
    forms: [
      { name: "Form IT-40", description: "Individual Income Tax Return", pdfUrl: "https://www.in.gov/dor/tax-forms/individual-income-tax-forms/" }
    ]
  },
  {
    state: "Iowa",
    agency: "Iowa Department of Revenue",
    agencyUrl: "https://tax.iowa.gov/",
    forms: [
      { name: "Form IA 1040", description: "Individual Income Tax Return", pdfUrl: "https://tax.iowa.gov/forms" }
    ]
  },
  {
    state: "Kansas",
    agency: "Kansas Department of Revenue",
    agencyUrl: "https://www.ksrevenue.gov/",
    forms: [
      { name: "Form K-40", description: "Individual Income Tax Return", pdfUrl: "https://www.ksrevenue.gov/forms.html" }
    ]
  },
  {
    state: "Kentucky",
    agency: "Kentucky Department of Revenue",
    agencyUrl: "https://revenue.ky.gov/",
    forms: [
      { name: "Form 740", description: "Individual Income Tax Return", pdfUrl: "https://revenue.ky.gov/Forms/Current%20Year%20Individual%20Income%20Forms.pdf" }
    ]
  },
  {
    state: "Louisiana",
    agency: "Louisiana Department of Revenue",
    agencyUrl: "https://revenue.louisiana.gov/",
    forms: [
      { name: "Form IT-540", description: "Resident Individual Income Tax Return", pdfUrl: "https://revenue.louisiana.gov/IndividualIncomeTax" }
    ]
  },
  {
    state: "Maine",
    agency: "Maine Revenue Services",
    agencyUrl: "https://www.maine.gov/revenue/",
    forms: [
      { name: "Form 1040ME", description: "Individual Income Tax Return", pdfUrl: "https://www.maine.gov/revenue/taxes/income-estate-tax/individual-income-tax" }
    ]
  },
  {
    state: "Maryland",
    agency: "Comptroller of Maryland",
    agencyUrl: "https://www.marylandtaxes.gov/",
    forms: [
      { name: "Form 502", description: "Resident Income Tax Return", pdfUrl: "https://www.marylandtaxes.gov/forms/current_forms/index.php" }
    ]
  },
  {
    state: "Massachusetts",
    agency: "Massachusetts Department of Revenue",
    agencyUrl: "https://www.mass.gov/dor",
    forms: [
      { name: "Form 1", description: "Resident Income Tax Return", pdfUrl: "https://www.mass.gov/lists/personal-income-tax-forms" }
    ]
  },
  {
    state: "Michigan",
    agency: "Michigan Department of Treasury",
    agencyUrl: "https://www.michigan.gov/treasury",
    forms: [
      { name: "Form MI-1040", description: "Individual Income Tax Return", pdfUrl: "https://www.michigan.gov/taxes/iit/forms" }
    ]
  },
  {
    state: "Minnesota",
    agency: "Minnesota Department of Revenue",
    agencyUrl: "https://www.revenue.state.mn.us/",
    forms: [
      { name: "Form M1", description: "Individual Income Tax Return", pdfUrl: "https://www.revenue.state.mn.us/forms-and-instructions" }
    ]
  },
  {
    state: "Mississippi",
    agency: "Mississippi Department of Revenue",
    agencyUrl: "https://www.dor.ms.gov/",
    forms: [
      { name: "Form 80-105", description: "Resident Individual Income Tax Return", pdfUrl: "https://www.dor.ms.gov/individual/individual-income-tax-forms" }
    ]
  },
  {
    state: "Missouri",
    agency: "Missouri Department of Revenue",
    agencyUrl: "https://dor.mo.gov/",
    forms: [
      { name: "Form MO-1040", description: "Individual Income Tax Return", pdfUrl: "https://dor.mo.gov/forms/income/" }
    ]
  },
  {
    state: "Montana",
    agency: "Montana Department of Revenue",
    agencyUrl: "https://mtrevenue.gov/",
    forms: [
      { name: "Form 2", description: "Individual Income Tax Return", pdfUrl: "https://mtrevenue.gov/taxes/individual-income-tax/" }
    ]
  },
  {
    state: "Nebraska",
    agency: "Nebraska Department of Revenue",
    agencyUrl: "https://revenue.nebraska.gov/",
    forms: [
      { name: "Form 1040N", description: "Individual Income Tax Return", pdfUrl: "https://revenue.nebraska.gov/about/forms-and-instructions" }
    ]
  },
  {
    state: "Nevada",
    agency: "Nevada Department of Taxation",
    agencyUrl: "https://tax.nv.gov/",
    forms: [
      { name: "No State Income Tax", description: "Nevada does not have a state income tax", pdfUrl: "" }
    ]
  },
  {
    state: "New Hampshire",
    agency: "New Hampshire Department of Revenue Administration",
    agencyUrl: "https://www.revenue.nh.gov/",
    forms: [
      { name: "Limited Income Tax", description: "Only taxes interest and dividends income", pdfUrl: "https://www.revenue.nh.gov/forms/index.htm" }
    ]
  },
  {
    state: "New Jersey",
    agency: "New Jersey Division of Taxation",
    agencyUrl: "https://www.nj.gov/treasury/taxation/",
    forms: [
      { name: "Form NJ-1040", description: "Resident Income Tax Return", pdfUrl: "https://www.nj.gov/treasury/taxation/forms/njit.shtml" }
    ]
  },
  {
    state: "New Mexico",
    agency: "New Mexico Taxation and Revenue Department",
    agencyUrl: "https://www.tax.newmexico.gov/",
    forms: [
      { name: "Form PIT-1", description: "Personal Income Tax Return", pdfUrl: "https://www.tax.newmexico.gov/individuals/file-your-taxes-overview/" }
    ]
  },
  {
    state: "New York",
    agency: "New York State Department of Taxation and Finance",
    agencyUrl: "https://www.tax.ny.gov/",
    forms: [
      { name: "Form IT-201", description: "Resident Income Tax Return", pdfUrl: "https://www.tax.ny.gov/pdf/current_forms/it/it201.pdf" },
      { name: "Form IT-203", description: "Nonresident and Part-Year Resident Income Tax Return", pdfUrl: "https://www.tax.ny.gov/pdf/current_forms/it/it203.pdf" }
    ]
  },
  {
    state: "North Carolina",
    agency: "North Carolina Department of Revenue",
    agencyUrl: "https://www.ncdor.gov/",
    forms: [
      { name: "Form D-400", description: "Individual Income Tax Return", pdfUrl: "https://www.ncdor.gov/taxes-forms/individual-income-tax" }
    ]
  },
  {
    state: "North Dakota",
    agency: "North Dakota Office of State Tax Commissioner",
    agencyUrl: "https://www.tax.nd.gov/",
    forms: [
      { name: "Form ND-1", description: "Individual Income Tax Return", pdfUrl: "https://www.tax.nd.gov/forms" }
    ]
  },
  {
    state: "Ohio",
    agency: "Ohio Department of Taxation",
    agencyUrl: "https://tax.ohio.gov/",
    forms: [
      { name: "Form IT 1040", description: "Individual Income Tax Return", pdfUrl: "https://tax.ohio.gov/individual/resources/forms" }
    ]
  },
  {
    state: "Oklahoma",
    agency: "Oklahoma Tax Commission",
    agencyUrl: "https://oklahoma.gov/tax.html",
    forms: [
      { name: "Form 511", description: "Resident Individual Income Tax Return", pdfUrl: "https://oklahoma.gov/tax/individuals/income-tax/forms.html" }
    ]
  },
  {
    state: "Oregon",
    agency: "Oregon Department of Revenue",
    agencyUrl: "https://www.oregon.gov/dor",
    forms: [
      { name: "Form OR-40", description: "Individual Income Tax Return", pdfUrl: "https://www.oregon.gov/dor/forms/Pages/personal-income-tax.aspx" }
    ]
  },
  {
    state: "Pennsylvania",
    agency: "Pennsylvania Department of Revenue",
    agencyUrl: "https://www.revenue.pa.gov/",
    forms: [
      { name: "Form PA-40", description: "Personal Income Tax Return", pdfUrl: "https://www.revenue.pa.gov/FormsandPublications/FormsforIndividuals/PIT/Pages/default.aspx" }
    ]
  },
  {
    state: "Rhode Island",
    agency: "Rhode Island Division of Taxation",
    agencyUrl: "https://tax.ri.gov/",
    forms: [
      { name: "Form RI-1040", description: "Resident Individual Income Tax Return", pdfUrl: "https://tax.ri.gov/forms" }
    ]
  },
  {
    state: "South Carolina",
    agency: "South Carolina Department of Revenue",
    agencyUrl: "https://dor.sc.gov/",
    forms: [
      { name: "Form SC1040", description: "Individual Income Tax Return", pdfUrl: "https://dor.sc.gov/forms-site/Forms/IITPacket_2023.pdf" }
    ]
  },
  {
    state: "South Dakota",
    agency: "South Dakota Department of Revenue",
    agencyUrl: "https://dor.sd.gov/",
    forms: [
      { name: "No State Income Tax", description: "South Dakota does not have a state income tax", pdfUrl: "" }
    ]
  },
  {
    state: "Tennessee",
    agency: "Tennessee Department of Revenue",
    agencyUrl: "https://www.tn.gov/revenue.html",
    forms: [
      { name: "No State Income Tax", description: "Tennessee does not have a state income tax", pdfUrl: "" }
    ]
  },
  {
    state: "Texas",
    agency: "Texas Comptroller of Public Accounts",
    agencyUrl: "https://comptroller.texas.gov/",
    forms: [
      { name: "No State Income Tax", description: "Texas does not have a state income tax", pdfUrl: "" }
    ]
  },
  {
    state: "Utah",
    agency: "Utah State Tax Commission",
    agencyUrl: "https://tax.utah.gov/",
    forms: [
      { name: "Form TC-40", description: "Individual Income Tax Return", pdfUrl: "https://tax.utah.gov/forms" }
    ]
  },
  {
    state: "Vermont",
    agency: "Vermont Department of Taxes",
    agencyUrl: "https://tax.vermont.gov/",
    forms: [
      { name: "Form IN-111", description: "Vermont Income Tax Return", pdfUrl: "https://tax.vermont.gov/individuals/personal-income-tax" }
    ]
  },
  {
    state: "Virginia",
    agency: "Virginia Department of Taxation",
    agencyUrl: "https://www.tax.virginia.gov/",
    forms: [
      { name: "Form 760", description: "Resident Individual Income Tax Return", pdfUrl: "https://www.tax.virginia.gov/forms" }
    ]
  },
  {
    state: "Washington",
    agency: "Washington Department of Revenue",
    agencyUrl: "https://dor.wa.gov/",
    forms: [
      { name: "No State Income Tax", description: "Washington does not have a state income tax", pdfUrl: "" }
    ]
  },
  {
    state: "West Virginia",
    agency: "West Virginia State Tax Department",
    agencyUrl: "https://tax.wv.gov/",
    forms: [
      { name: "Form IT-140", description: "Personal Income Tax Return", pdfUrl: "https://tax.wv.gov/Individuals/Pages/IndividualIncomeTax.aspx" }
    ]
  },
  {
    state: "Wisconsin",
    agency: "Wisconsin Department of Revenue",
    agencyUrl: "https://www.revenue.wi.gov/",
    forms: [
      { name: "Form 1", description: "Individual Income Tax Return", pdfUrl: "https://www.revenue.wi.gov/Pages/Form/home.aspx" }
    ]
  },
  {
    state: "Wyoming",
    agency: "Wyoming Department of Revenue",
    agencyUrl: "https://revenue.wyo.gov/",
    forms: [
      { name: "No State Income Tax", description: "Wyoming does not have a state income tax", pdfUrl: "" }
    ]
  }
];

export const allStates = [
  "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware",
  "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky",
  "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi",
  "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico",
  "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania",
  "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont",
  "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
];